import { useRestClient, RestSchemas } from '@/contexts/QueryProvider'
import { useCallback } from 'react'
import { useParams } from 'react-router'

type MessagesSubscriptionsOrganisationSummary = RestSchemas['Messages.Subscriptions.OrganisationSummary']

export function useCurrentOrganisation(id?: number) {
  const params = useParams()
  const organisationId = id ?? Number(params.organisationId)
  const { getSubscriptionsApiGetOrganisations } = useRestClient()

  const select = useCallback(
    (data: MessagesSubscriptionsOrganisationSummary[]) => data.find((x) => x.id === organisationId),
    [organisationId]
  )

  const { data: organisation } = getSubscriptionsApiGetOrganisations.useSuspenseQuery(undefined, {
    select,
  })

  if (!organisation) {
    throw new Error('Organisation not found')
  }

  return organisation
}
